import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      '& .notificationsListItem': {
        '&.notificationunread': {
          '& .notificationMessageGridItem': {
            [theme.breakpoints.down('sm')]: {
              marginLeft: 30,
            },
          },
        },
      },
      '& .notificationread': {
        backgroundColor: theme.palette.common.backgroundDark,
      },
    },
    notificationButton: {
      width: '100%',
      padding: 20,
    },
    notificationText: {
      textTransform: 'initial',
      color: theme.palette.common.tan,
      textAlign: 'left',
    },
    newNotification: {
      backgroundColor: theme.palette.common.coral,
      width: 10,
      height: 10,
      borderRadius: '100%',
      marginRight: 20,
      marginTop: 5,
      alignSelf: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        order: '-1',
      },
    },
    notificationlink: {
      fontWeight: 500,
      fontSize: 12,
      display: 'flex',
      alignItems: 'center',
      textTransform: 'uppercase',
      marginTop: 5,
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        marginTop: 10,
      },
    },
    notificationDateGridItem: {
      marginLeft: 'auto',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '0',
        order: '-1',
        marginBottom: 5,
      },
    },
    notificationDate: {
      fontSize: 12,
      fontWeight: 500,
      textTransform: 'uppercase',
      textAlign: 'right',
      color: theme.palette.common.grey,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
      },
    },
    arrowIcon: {
      height: 20,
      backgroundSize: '20px 14px!important',
      marginLeft: 5,
      [theme.breakpoints.down('sm')]: {
        backgroundSize: '20px 15px!important',
        width: '35px!important',
      },
    },
  });

export default styles;
